import { Platform } from "react-native";

/**
 * Shared input sizes, including the larger entry used by glass date fields.
 *
 * iOS Safari zooms into any input with font-size < 16px when the input
 * receives focus. On native and mobile-web (touch) devices we always
 * return 16. Desktop-web (non-touch) uses 14. Large entries retain 18
 * on every platform.
 */
export function useInputFontSize(
  size: "adaptive" | "large" = "adaptive",
): number {
  if (size === "large") return 18;
  if (Platform.OS !== "web") return 16;
  if (
    typeof window !== "undefined" &&
    window.matchMedia("(pointer: coarse)").matches
  ) {
    return 16;
  }
  return 14;
}
